<template>
  <div class="action-buttons pt-4 mt-3 col-lg-8">
    <div class="row form-group text-center text-lg-left pb-2">
      <div class="col-sm mb-3 mb-lg-0 pl-lg-0">
        <SmagriaButton :label="$t('common.back_to_list')" customClass="secondary" width="100%" :action="onGotoList" />
      </div>
      <div class="col-sm mb-3 mb-lg-0" v-if="canEdit">
        <SmagriaButton :label="$t('common.save')" customClass="primary" width="100%" :action="onSave" />
      </div>
      <div class="col-sm mb-3 mb-lg-0" v-if="canEdit && !data.uuid && saveAndNew">
        <SmagriaButton :label="$t('common.save_and_new')" customClass="success" width="100%" :action="onSaveAndNew" />
      </div>
      <div class="col-sm" v-if="data.uuid && canDelete">
        <SmagriaButton :label="$t('common.delete')" customClass="danger" width="100%" :action="onDelete" />
      </div>
    </div>
  </div>
</template>

<script>
import SmagriaButton from "@/components/Common/SmagriaButton.vue";

export default {
  name: 'AgroActionButtons',
  components: { SmagriaButton },
  props: {
    data: {
      type: Object,
    },
    gotoList: {
      type: Function|null,
    },
    canEdit: {
      type: Boolean|null,
    },
    canDelete: {
      type: Boolean|null,
    },
    saveAndNew: {
      type: Boolean|null,
    },
  },
  methods: {
    onSave() {
      this.$emit('onSave', this.data);
    },
    onSaveAndNew() {
      this.$emit('onSaveAndNew', this.data);
    },
    onDelete() {
      this.$emit('onDelete', this.data);
    },
    onGotoList() {
      this.$emit('onGotoList', this.data);
    }
  }
}
</script>
